import { useCallback } from "react";
import { Avatar, Button, Col, Row } from "antd";
import { UserOutlined } from "@ant-design/icons";
import paperClip from "assets/icons/paper-clip.svg";
import { EASResultType } from "redux/reducers/EASSlice";
import { useTranslation } from "react-i18next";
import { capitalize, isEmpty } from "lodash";
import styles from "./style.module.scss";
import { TableToolTip } from "components/common/table-title/tooltip";

interface EASSearchResultCardProps {
  easResult: EASResultType;
  setIsEISModalOpen: (flag: boolean) => void;
  setSelectedStudent: (student: any) => void;
}

export default function EASSearchResultCard({
  easResult,
  setIsEISModalOpen,
  setSelectedStudent
}: EASSearchResultCardProps) {
  const { t } = useTranslation();
  const { studentNumber: id, givenName1, familyName, easApplicantDocuments } = easResult;

  const handleClickUpload = useCallback(() => {
    setIsEISModalOpen(true);
    setSelectedStudent(easResult);
  }, [easResult.studentNumber]);

  return (
    <div className={styles.container}>
      <Row>
        <Col xs={24} sm={18}>
          <div className={styles["user-container"]}>
            <Avatar icon={<UserOutlined />} size={40} className={styles.avatar} />
            <div>
              <div className={styles.name}>
                {capitalize(givenName1)} {capitalize(familyName)}
              </div>
              <div className={styles.id}>
                <div style={{ marginRight: 4 }}>Student ID</div>
                <TableToolTip
                  iconColor="grey"
                  title={"students.studentID"}
                  altText={"students.studentID"}
                />
                <div style={{ marginLeft: 8 }}>{id}</div>
              </div>
              {!isEmpty(easApplicantDocuments) && (
                <strong className={styles.upload}>
                  {t("easApplications.search.result.card.uploadInfo")}
                </strong>
              )}
              {easApplicantDocuments?.map(doc => (
                <div key={doc.fileReference}>
                  <img src={paperClip} alt="" />
                  &nbsp;&nbsp;
                  <span style={{ fontSize: 14 }}>{doc.documentName}</span>
                </div>
              ))}
            </div>
          </div>
        </Col>
        <Col xs={24} sm={6} className={styles["last-col"]}>
          <Button type="primary" onClick={handleClickUpload}>
            {t("easApplications.search.result.card.uploadCTA")}
          </Button>
        </Col>
      </Row>
    </div>
  );
}
